const SDK_GLOBAL_NAME = "WidgetSDK";
const SDK_CDN_URL =
  "https://cdn.jsdelivr.net/npm/@moysklad-official/js-widget-sdk/dist/widget.min.js";

let sdkLoadPromise = null;

function hasSdk() {
  return typeof window !== "undefined" && !!window[SDK_GLOBAL_NAME];
}

export async function loadWidgetSdk() {
  if (hasSdk()) {
    return window[SDK_GLOBAL_NAME];
  }

  if (!sdkLoadPromise) {
    sdkLoadPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = SDK_CDN_URL;
      script.async = true;
      script.onload = () => {
        if (!hasSdk()) {
          reject(new Error("WidgetSDK was not found in window after script load"));
          return;
        }
        resolve(window[SDK_GLOBAL_NAME]);
      };
      script.onerror = () => {
        reject(new Error("Failed to load widget SDK script"));
      };
      document.head.appendChild(script);
    });
  }

  return sdkLoadPromise;
}

